import type { Endpoint, Route, Request, RequestArgs } from '../types.no-deps'
import type { ReportClientId } from '../../../shared/domain/reports/types.no-deps'
import type { OngoingReportChanges } from '../../../shared/domain/reports/ongoingReport.no-deps'

export const route: Route = { method: 'GET', pattern: '/api/reports/:reportClientId/ongoingChanges' }

type Params = { reportClientId: ReportClientId }
type Body = never
type Query = { lastSyncTime: Date }
type Output = OngoingReportChanges & { syncTime: Date }

export type GetOngoingChangesEndpoint = Endpoint<Params, Body, Query, Output>

export const getOngoingChangesRequest = (request: Request, args: RequestArgs<GetOngoingChangesEndpoint>) =>
    request<GetOngoingChangesEndpoint>(route, args)
